<template>
    <div id="cart-contact-info" :class="['align-middle', 'cart-contact-info', 'grid-x', 'align-justify', { open: editMode }]">
        <div class="cell shrink">
            <p class="display-large color-dark-gray cart-title semi-bold">Contact Info</p>
        </div>
        <div class="cell shrink" v-if="canBeClosed">
            <p class="cart-edit cart-title">
                <a @click="editMode = !editMode">{{ editMode ? 'Close' : 'Edit' }}</a>
            </p>
        </div>
        <div class="cell" v-if="!editMode">
            <p class="margin-0">{{ userName }}</p>
            <p class="margin-0">{{ userEmail }}</p>
        </div>
        <div class="cell" v-else>
            <text-input label="Full name" type="text" name="name" autocomplete="name" :value="userName" @change="userName = $event" @blur="validateField('name')" :error-message="errorMessage('name')" :required="true"></text-input>
            <text-input label="Email" type="email" name="email" autocomplete="email" :value="userEmail" @change="userEmail = $event" @blur="validateField('email')" :error-message="errorMessage('email')" :required="true"></text-input>
            <phone-input :required="true" :value="userPhone" name="phone" placeholder="Phone*" :preferred-countries="['US', 'KY', 'CA', 'GB']" default-country="KY" mode="international" @change="userPhone = $event" @validate="validatePhone" :error-message="errorMessage('phone')"> </phone-input>
        </div>
    </div>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import UserModule from '@/stores/modules/user';
import { getModule } from 'vuex-module-decorators';
import TextInput from '@/components/common/forms/TextInput.vue';
import Checkbox from '@/components/common/ui/Checkbox.vue';
import { NotificationChannel } from '@/models/user';
import CartModule from '@/stores/modules/cart';
import PhoneInput from '@/components/common/forms/PhoneInput.vue';
@Component({
    components: { TextInput, Checkbox, PhoneInput },
})
export default class CartContactInfo extends Vue {
    userModule!: UserModule;
    cartModule!: CartModule;
    editMode: boolean = false;


    async created() {
        this.userModule = getModule(UserModule, this.$store);
        this.cartModule = getModule(CartModule, this.$store);
    }

    mounted() {
        if (!this.canBeClosed) {
            this.editMode = true;
            if (!this.notifyBy) {
                this.notifyBy = NotificationChannel.EMAIL_SMS;
            }
        }
        if (this.userModule.draftUser) {
            this.cartModule.setFullName(this.userModule.draftUser.name);
            this.cartModule.setPhone(this.userModule.draftUser.phone);
            this.cartModule.setEmail(this.userModule.draftUser.email);
            if (this.userModule.draftUser.membership_number) {
                this.cartModule.setMembershipNumber(this.userModule.draftUser.membership_number);
            }
        }
    }

    openLoginModal() {
        this.userModule.openLoginModal();
    }

    validateField(field: string) {
        this.cartModule.validateCheckoutField(field);
    }

    validatePhone(phoneObject: any) {
        this.cartModule.validatePhone(phoneObject);
    }

    get hasError() {
        return (field: string) => {
            return this.cartModule.checkoutErrors.find((error) => error.source === field) !== undefined;
        };
    }

    get user() {
        return this.userModule.currentUser;
    }

    get canBeClosed() {
        return this.cartModule.checkoutErrors.filter((error) => error.source === 'phone' || error.source === 'email' || error.source === 'name').length === 0 && this.userEmail && this.userPhone && this.userName;
    }

    get userEmail() {
        return this.cartModule.checkoutFields.email.value;
    }

    set userEmail(value: string) {
        this.cartModule.clearCheckoutError('email');
        this.cartModule.setEmail(value);
    }

    get userName() {
        return this.cartModule.checkoutFields.name.value;
    }

    set userName(value: string) {
        this.cartModule.clearCheckoutError('name');
        this.cartModule.setFullName(value);
    }

    get userPhone() {
        return this.cartModule.checkoutFields.phone.value;
    }

    set userPhone(value: string) {
        this.cartModule.setPhone(value);
    }

    get notifyBy() {
        if (this.userModule.draftUser) {
            return this.userModule.draftUser.notify_by;
        }
        return NotificationChannel.EMAIL_SMS;
    }

    set notifyBy(value: string) {
        if (this.userModule.draftUser) {
            this.userModule.setUserValue({ key: 'notify_by', value });
        }
    }

    get parsedNotifyBy() {
        if (this.notifyBy === NotificationChannel.SMS_ONLY) return 'SMS';
        if (this.notifyBy === NotificationChannel.EMAIL_ONLY) return 'Email';
        return 'Email + SMS';
    }

    get NotificationChannel() {
        return NotificationChannel;
    }

    get errorMessage() {
        return (field: string) => {
            const error = this.cartModule.checkoutErrors.find((error) => error.source === field);
            if (error) {
                return error.message;
            }
        };
    }
}
</script>
<style>
.cart-contact-info {
    border-top: var(--cart-separator);
    border-color: var(--cart-separator-color);
    padding: 15px 0;
}
</style>
